module.exports = __webpack_public_path__ + "static/media/arrow.131e0202.svg";